export default "__VITE_ASSET__6okiVqSU__"